export default function SandboxDashboardHome() {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6">Dashboard Overview</h1>
      <div className="grid gap-4 md:grid-cols-2">
        <div className="p-6 bg-card border border-border rounded-lg">
          <h3 className="font-semibold mb-2">Total Users</h3>
          <p className="text-3xl font-bold text-primary">1,234</p>
        </div>
        <div className="p-6 bg-card border border-border rounded-lg">
          <h3 className="font-semibold mb-2">Active Sessions</h3>
          <p className="text-3xl font-bold text-primary">56</p>
        </div>
      </div>
    </div>
  );
}
